import React, { useEffect, useState } from "react";
import Header from "../../../../CommonComponents/header";
import { Footer } from "../../../../CommonComponents/footer";
import { ProductCategoryHeroSection } from "../../Components/productCategoryHeroSection";
import { RightImagesTextcard } from "../../Components/rightImageTextCard";
import { LeftImagesTextCard } from "../../Components/leftImagesTextcard";
import { WhyProductCategorySection } from "../../Components/whyProductCategorysection";
import { MobileHeader } from "../../../../CommonComponents/mobileHeader";
import { useParams } from "react-router-dom";
import { baseurl } from "../../../../CommonComponents/baseurl";
import { useDispatch } from "react-redux";
import { allSlugData, setProgress } from "../../../../Redux/ReduxFunction";
import NotFoundComp from "../../../../CommonComponents/notFoundComp";
import { MainHeading } from "../../../../subComponents/MainHeading";

const HomeInterior = () => {
  const [currentcategory, setCurrentcategory] = useState([]);
  const [subcategorylist, setSubcategorylist] = useState([]);
  const [isDataLoad, setIsDataLoad] = useState(false);

  const { slug } = useParams();

  var dispatch = useDispatch();

  useEffect(() => {
    dispatch(allSlugData("data"));
    const fetchCategory = async () => {
      console.log(slug, "hello world");

      if (!slug) return;
      try {
        const formData = new FormData();
        formData.append("slug", slug);

        const response = await fetch(`${baseurl}/api/sub-category`, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();
        // console.log("Fetched data:", data);
        if (data.success === "1") {
          setCurrentcategory(data);
          setSubcategorylist(data.data);
          dispatch(setProgress(data.meta_title));
        } else {
          console.error("Failed to fetch data:", data.message);
        }

        if (data.success === "6") {
          setIsDataLoad(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  useEffect(() => {
    // console.log("Category state updated:", currentcategory);
  }, [currentcategory]);

  return (
    <>
      <Header />
      <MobileHeader />

      <div className="desktop_header_spacer"></div>

      {isDataLoad ? (
        <NotFoundComp />
      ) : (
        <>
          <ProductCategoryHeroSection
            title={currentcategory.page_title}
            content={currentcategory.page_description}
            show={false}
            showinterior={true}
            subcategorylist={subcategorylist}
            categoryslug={currentcategory.slug}
            bannerImage={currentcategory.page_banner ?? null}
          />

          {slug === "extrusion-manufacturing" ? (
            <>
              <WhyProductCategorySection
                title={"Cost-Effective"}
                content={
                  <>
                    Extrusion Product are affordable to produce and install,
                    reducing overall system costs.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog2.webp"}
              />

              <section className="upvc_benefit_section">
                <div
                  style={{
                    width: "max-content",
                    margin: "auto",
                    padding: "2rem 0",
                  }}
                >
                  <MainHeading title={"Benefits of Metal Tubes"} />
                </div>

                <RightImagesTextcard
                  orangeheading={"Energy"}
                  title=" -  & Resource Savings"
                  content={
                    <>
                      Lightweight design reduces transport and handling costs,
                      and its low friction ensures efficient fluid flow.{" "}
                    </>
                  }
                  imageurl={"/assets/images/new_images/blogs/blog5.jpg"}
                />
                <LeftImagesTextCard
                  orangeheading={"Low Maintenance"}
                  title={"and Durability"}
                  content={
                    <>
                      Highly resistant to corrosion, chemicals, and wear, nylon
                      tubes require minimal maintenance and have a long service
                      life.
                    </>
                  }
                  imageurl={"/assets/images/new_images/blogs/blog4.jpg"}
                />
                <RightImagesTextcard
                  orangeheading={"Enhanced"}
                  title=" - Safety"
                  content={
                    <>
                      Non-toxic, abrasion-resistant, and flexible, nylon tubes
                      reduce risks of leaks, breakages, or system failures.{" "}
                    </>
                  }
                  imageurl={"/assets/images/new_images/blogs/blog3.jpg"}
                />
                <LeftImagesTextCard
                  orangeheading={"Operational"}
                  title={"Efficiency"}
                  content={
                    <>
                      Smooth inner surfaces and excellent dimensional stability
                      ensure consistent performance under pressure, temperature,
                      and vibration.{" "}
                    </>
                  }
                  imageurl={"/assets/images/new_images/blogs/blog1.jpg"}
                />
              </section>
            </>
          ) : (
            ""
          )}

          {slug === "metal-tube-bending-and-assy" ? (
            <>
              <WhyProductCategorySection
                title={"Cost-Effective"}
                content={
                  <>
                    Durable materials and precise manufacturing reduce
                    replacement frequency and long-term operational costs.
                  </>
                }
                imageurl={
                  "/assets/images/new_images/recent_project/industrial-metal-drill-machine-metalworking-workshop_342744-520.jpg"
                }
              />
              <div
                style={{
                  margin: "auto",
                  padding: "2rem 0",
                  textAlign: "center",
                }}
              >
                <MainHeading title={"Benefits of Nylon Tube Assemblies"} />
              </div>
              <RightImagesTextcard
                orangeheading="Energy "
                title="& Resource Savings"
                content={
                  <>
                    High strength-to-weight ratio and optimized design minimize
                    material use while maintaining performance
                  </>
                }
                imageurl={
                  "/assets/images/new_images/recent_project/istockphoto-457740707-612x612.jpg"
                }
              />
              <LeftImagesTextCard
                orangeheading={"Low"}
                title={"Maintenance"}
                content={
                  <>
                    Resistant to wear, pressure, and temperature fluctuations,
                    requiring minimal inspection and upkeep.
                  </>
                }
                imageurl={
                  "/assets/images/new_images/recent_project/harvesters-combine-parts-plant-are-waiting-sales_146671-19060.jpg"
                }
              />
              <RightImagesTextcard
                orangeheading={"Enhanced"}
                title="Safety"
                content={
                  <>
                    Robust construction and reliable fittings prevent leaks,
                    bursts, and operational hazards.
                  </>
                }
                imageurl={
                  "/assets/images/new_images/recent_project/industrial-metal-drill-machine-metalworking-workshop_342744-520.jpg"
                }
              />
              <LeftImagesTextCard
                orangeheading={"Operational"}
                title={"Efficiency"}
                content={
                  <>
                    Precision-engineered assemblies ensure consistent flow, easy
                    installation, and compatibility with complex systems.
                  </>
                }
                imageurl={
                  "/assets/images/new_images/recent_project/download.jpeg"
                }
              />
            </>
          ) : (
            ""
          )}

          {slug === "others" ? (
            <>
              <WhyProductCategorySection
                title={"Cost-Effective"}
                content={
                  <>
                    Affordable material and simple application reduce labor and
                    replacement costs.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog5.jpg"}
              />
              <div
                style={{
                  margin: "auto",
                  padding: "2rem 0",
                  textAlign: "center",
                }}
              >
                <MainHeading title={"Benefits of Manufacturing"} />
              </div>
              <RightImagesTextcard
                orangeheading={"Energy"}
                title="& Resource Savings"
                content={
                  <>
                    Lightweight and easy to install, minimizing time and
                    material waste.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog1.jpg"}
              />
              <LeftImagesTextCard
                orangeheading={"Low"}
                title={"Maintenance"}
                content={
                  <>
                    Resistant to moisture, chemicals, abrasion, and UV,
                    requiring minimal upkeep.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog2.webp"}
              />
              <RightImagesTextcard
                orangeheading={"Enhanced "}
                title="Safety"
                content={
                  <>
                    Provides electrical insulation, protects against short
                    circuits, mechanical damage, and environmental exposure.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog3.jpg"}
              />
              <LeftImagesTextCard
                orangeheading={"Operational "}
                title={"Efficiency"}
                content={
                  <>
                    Ensures reliable connections, neat assemblies, and long-term
                    durability.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog4.jpg"}
              />
            </>
          ) : (
            ""
          )}

          <div style={{ height: "3rem" }}></div>
        </>
      )}

      <Footer />
    </>
  );
};
export { HomeInterior };
